<template>
    <div class="rodemap">
        <div class="mask05"></div>
        <ShopItem :data="data" @jump="jump" @finish="finish"></ShopItem>
    </div>
</template>

<script>
    //script
    import Tools from '../../../scripts/tools';
    import {gsap} from 'gsap';
    //Global
    import Global from '../../../scripts/Global';
    import ShopItem from '../../cmp/shopItem';

    export default {
        data() {
            return {
                data: {
                    headTipImg: '乔诗语讲解',
                    headTipTxt: '答不出来也没事啦，我知道你的强项不在这，走，去下一处！',
                    headTipPathTxt: '前往位育斋 >>',
                    headTipPath: '/rodemap/qsy/08',

                    qText: '以下那首诗歌是在描写御花园？',
                    errText: '快来看，马上要选秀女了！你知道怎样算是选中了吗？',
                    okText: '快来看，马上要选秀女了！你知道怎样算是选中了吗？',

                    answerArr: [
                        {
                            txt: '采菊东篱下<br/>悠然见南山',
                        },
                        {
                            txt: '故宫登楼名偶似<br/>远眺欲见蓬瀛洲',
                            right: true,
                        },
                        {
                            txt: '玉树琼花蔚上林<br/>琼楼玉宇缀芳芬',
                        },
                    ],
                },
            };
        },
        components: {
            ShopItem,
        },
        created() {
            Global.pauseAll();
            Global.startPlay('qsy', 'scene13_2');
        },
        computed: {},
        methods: {
            jump(event) {
                if (event) {

                } else {
                }
            },
            finish(event) {
                Global.yubi.qsy.b4 = true;
                let headTipPath = '';
                let ybtxt = '';
                if (Object.keys(Global.yubi.qsy).length >= 4) {
                    headTipPath = '/bonus?giftRoad=qsy';
                    ybtxt="";
                    // ybtxt = `嗯，表现不错嘛，拿着刚刚的玉璧去抽奖吧，我在这里等你。我的朋友也还在等你呢。`;
                } else {
                    headTipPath = '/result';
                }

                Global.curr = {
                    ...this.data,
                    headTipImg: '乔诗语讲解',
                    headTipTxt: '啊，这个送给你啦',
                    headTipPath,
                    headTipPathTxt: '前往下一处 >>',
                    ybtxt,
                    bg: '位育斋',
                    ybResultImg: '乔诗语',
                    ybResultHTML: `<p>今天的约会很开心呢！</p>
        <p>嗷~没收集到4枚玉璧，不能抽奖，别气馁，继续挑战本关，或者选择其他路线争取集齐玉璧吧！</p>`,
                    ybCallback: () => {
                        if (Object.keys(Global.yubi.qsy).length >= 4) {
                            setTimeout(() => {
                                Global.startPlay('qsy', 'scene15');
                            }, 500);
                        } else {
                            setTimeout(() => {
                                Global.startPlay('qsy', 'scene14');
                            }, 500);
                        }
                    },
                };
                Global.startPlay('qsy', 'scene13_3');
                this.$router.replace('/yu');
            },
        },
    };
</script>

<style lang="scss">
    .answer-box {
        .a {
            line-height: 0.4rem !important;
        }
    }
    .head-tip-man {
        .txt {
            margin: 0 0.5rem 0 0.5rem !important;
        }
    }
</style>

<style rel="stylesheet/scss" lang="scss" scoped>
    .rodemap {
        background-image: url(//cdn.original-fun.com/gugong/位育斋.jpg);
        background-position: center;
        width: 100vw;
        height: 100vh;
        max-width: 75vh;
        margin: 0 auto;
        overflow: hidden;
        background-size: cover;
        background-repeat: no-repeat;
    }
</style>
